import { ContentClassEnum } from 'content-service-client';

import { OriginArea } from '@videoblocks/events-ts/lib/storyblocks/search/OriginAreaEnum';

const urlSegmentForContentClass = (contentClass: ContentClassEnum) => {
    // todo: need this fn at all? enum values match
    return (
        {
            [ContentClassEnum.Video]: 'video',
            [ContentClassEnum.Audio]: 'audio',
            [ContentClassEnum.Image]: 'image',
        }[contentClass] || null
    );
};

export function getPreviewUrl(stockItemId: number, contentClass: ContentClassEnum): string {
    const prefix = urlSegmentForContentClass(contentClass) ?? contentClass.toString();
    return `/${prefix}/${stockItemId}/download/preview`;
}

// wrapper around navigator.sendBeacon
export function sendBeacon(
    urlPath: string,
    stockItemId: number,
    position?: number,
    clickOriginArea?: OriginArea,
): boolean {
    let result = false;
    if (!navigator.sendBeacon) {
        return result;
    }

    const url = new URL(urlPath, location.origin);
    url.searchParams.set('stockItemId', stockItemId.toString());

    if (position) {
        url.searchParams.set('position', position.toString());
    }
    if (clickOriginArea) {
        url.searchParams.set('clickOriginArea', clickOriginArea);
    }

    try {
        result = navigator.sendBeacon(url.toString());
    } catch (error) {
        console.error('Error sending beacon:', error);
    }
    return result;
}

export function roundUpToClosestMinute(secs: number): number {
    return Math.ceil(secs / 60);
}
export function formatDurationForHumans(
    totalSeconds: number,
    options: {
        maxNumberOfSeconds?: number;
        formatMinutesUnit?: boolean;
    } = {},
): string {
    const { maxNumberOfSeconds, formatMinutesUnit = false } = options;

    // Round the total seconds first to handle decimal values
    const roundedTotalSeconds = Math.round(totalSeconds);
    const minutes = Math.floor(roundedTotalSeconds / 60);
    const seconds = roundedTotalSeconds % 60;

    const formatUnit = (unit: number, shouldFormat: boolean) => (shouldFormat ? `${unit}`.padStart(2, '0') : `${unit}`);

    const secondsString = formatUnit(seconds, seconds < 10);
    const minutesString = formatUnit(minutes, formatMinutesUnit && minutes < 10);

    if (maxNumberOfSeconds) {
        const maxNumberOfMinutes = roundUpToClosestMinute(maxNumberOfSeconds);
        if (minutes >= maxNumberOfMinutes) {
            return `${maxNumberOfMinutes}:00+`;
        }
    }

    return `${minutesString}:${secondsString}`;
}
export function formatDurationForMachines(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `PT${minutes}M${seconds}S`;
}
